import AvatarWithAccessPoint from "./AvatarWithAccessPoint";
import Avatar from "./Avatar";

export default Avatar;
export { AvatarWithAccessPoint };
